



























































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';

import SwWidgetHeader from './sw-widget-header.vue';
import SwWidgetBody from './sw-widget-body.vue';
import SwWidgetFooter from './sw-widget-footer.vue';
import SwWidgetLoading from './sw-widget-loading.vue';
import SwWidgetErrorComponent from './sw-widget-error-component.vue';
import { Widget } from '@/shared/types/widget-library.types';
import moment from 'moment';
import _ from 'lodash';

const cssPrefix = 'sw-widget';

@Component({
  components: {
    SwWidgetHeader,
    SwWidgetBody,
    SwWidgetFooter,
    SwWidgetLoading,
    SwWidgetErrorComponent,
  },
})

export default class SwWidget extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop()
  panelAttributes: Widget;

  @Prop({ required: true })
  index: number;

  @Prop({ required: true })
  component: any;

  @Prop({ type: Boolean, required: true, default: false })
  isPageRefresh: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  disableRemove: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  disableEdit: boolean;

  showLoading: boolean = true;
  showError: boolean = false;
  errorMessage: string = '';
  lastUpdatedTime: number = 0;
  footerTime: string = '';
  componentKey: number = 0;
  lastComponentProps: any;

  // computed property to pass props in the dynamic component
  get componentProps() {
    const props = {
      isPageRefresh: this.isPageRefresh,
      refreshRate: this.panelAttributes.refreshRate,
      dataGroup: this.panelAttributes.dataGroup,
      endpoint: this.panelAttributes.endpoint,
      advancedEndpoint: this.panelAttributes.advancedEndpoint ? this.panelAttributes.advancedEndpoint : '',
      advancedDrillDownUrl: this.panelAttributes.advancedDrillDownUrl,
      groupBy: this.panelAttributes.groupBy,
      isPercentage: this.panelAttributes.isPercentage,
      timeframe: this.panelAttributes.timeframe,
      apiParams: this.panelAttributes.widgetDropDownOption,
      drillDownUrl: this.panelAttributes.drillDownUrl,
      valuesSIUnit: this.panelAttributes.valuesSIUnit,
      uniqueTitle: this.panelAttributes.title,
      width: this.panelAttributes.w,
      attachDrillDownParams: this.panelAttributes.attachDrillDownParams,
      tenantGroup:
        this.panelAttributes.tenantGroup &&
        this.panelAttributes.tenantGroup.groupId
          ? this.panelAttributes.tenantGroup.groupId
          : '',
      tenantGroupDevices:
        this.panelAttributes.tenantGroup &&
        this.panelAttributes.tenantGroup.devices
          ? this.panelAttributes.tenantGroup.devices
          : [],
    };
    if (!_.isEqual(this.lastComponentProps, props)) {
      this.componentKey += 1;
      this.lastComponentProps = props;
    }
    return props;
  }

  // Function to Handle showError event
  handleError(event: any) {
    this.showError = event.showError;
    this.errorMessage = event.errorMessage || '';
  }

  // Watcher Function to watch Last Updated Time
  @Watch('lastUpdatedTime', { immediate: true })
  getUpdatedTime() {
    this.footerTime = moment
      .unix(this.lastUpdatedTime)
      .format('MMM D, YYYY, hh:mm A');
  }

  created() {
    this.lastComponentProps = this.componentProps;
  }
}
